import { observable, action } from "mobx";
import axios from "axios";

export default class ModalStore {

    @observable exibirModal;
    @observable activeTab;
    @observable submitted;
    @observable submitMensagemErro;
    @observable loading;
    @observable mensagemAlerta;

    constructor() {
        this.activeTab = '1';
        this.exibirModal = { tipo: null, aberto: false };
        this.submitted = false;
        this.submitMensagemErro = "";
    }

    setLoading = (value) => {
        this.loading = value;
    };

    setSubmitted = (value) => {
        this.submitted = value;
    };

    setSubmitMensagemErro = (value) => {
        this.submitMensagemErro = value;
    };

    setTab = (tab) => {
        this.activeTab = tab;
    };

    limparBackdropResidual = () => {
        setTimeout(() => {
            const possuiModalAberta = document.querySelector('.modal.in, .modal.show');

            if (possuiModalAberta) {
                return;
            }

            const body = document.body;
            if (body) {
                body.classList.remove('modal-open');
                body.classList.remove('ReactModal__Body--open');
                body.style.paddingRight = '';
                if (!body.style.cssText.trim()) {
                    body.removeAttribute('style');
                }
            }

            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => {
                backdrop.classList.remove('show');
                backdrop.classList.remove('in');
                backdrop.style.display = 'none';
                backdrop.style.opacity = '0';
                backdrop.style.pointerEvents = 'none';
                backdrop.setAttribute('aria-hidden', 'true');
            });

            const overlays = document.querySelectorAll('.ReactModal__Overlay');
            overlays.forEach(overlay => {
                overlay.style.display = 'none';
                overlay.style.pointerEvents = 'none';
            });
        }, 0);
    };

    toggleModal = (tipo = null) => {
        const vaiFechar = this.exibirModal.aberto;

        this.activeTab = '1';
        this.exibirModal = {
            tipo,
            aberto: !this.exibirModal.aberto
        };

        if (vaiFechar) {
            this.limparBackdropResidual();
        }
    };

    closeModal = (tipo = null) => {
        this.activeTab = '1';
        this.exibirModal = {
            tipo,
            aberto: false
        };

        this.limparBackdropResidual();
    };

}
